import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiBaseComponentsModule } from '@domgen/dgx-fe-base-components';
import { CommonUiSalesComponentsModule } from '@common/ui-sales-components';
import { ReinstateFeatureShellRoutingModule } from './reinstate-feature-shell-router.module';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { environment } from '@reinstate/util-environment';
import { META_REDUCERS } from './meta-reducers/meta-reducers';
import { ReinstateDataAccessReinstateModule } from '@reinstate/data-access-reinstate';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ReinstateAppComponent } from './components/reinstate-app/reinstate-app.component';
import {
  ENVIRONMENT,
  GOOGLE_TAG_GLOBAL_PROPERTIES,
} from '@common/util-foundation';
import {
  AppProvidersConfig,
  AppProvidersConfigToken,
  CommonFeatureCoreModule,
} from '@common/feature-core';
import {
  CorrelationIdPartialState,
  correlationIdReducer,
  CORRELATION_ID_KEY,
} from '@common/data-access-shared';
import { HeaderModule } from '@domgen/dgx-ui-whitelabel-components';
import { FeatureConfigFacade } from '@common/data-access-feature-config';
import { featureConfigGoogleTagGlobalPropsFactory } from './feature-config-google-tag-global-factory';

@NgModule({
  imports: [
    CommonModule,
    SharedUiBaseComponentsModule,
    CommonUiSalesComponentsModule,
    ReinstateFeatureShellRoutingModule,
    HeaderModule,
    StoreModule.forRoot(
      {
        [CORRELATION_ID_KEY]: correlationIdReducer,
      } as ActionReducerMap<
        CorrelationIdPartialState & Record<string, unknown>
      >,
      {
        metaReducers: !environment.production
          ? [...META_REDUCERS]
          : [...META_REDUCERS],
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      }
    ),
    ReinstateDataAccessReinstateModule,
    EffectsModule.forRoot(),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    CommonFeatureCoreModule,
  ],
  declarations: [ReinstateAppComponent],
  exports: [ReinstateAppComponent],
  providers: [
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    {
      provide: GOOGLE_TAG_GLOBAL_PROPERTIES,
      useFactory: featureConfigGoogleTagGlobalPropsFactory,
      deps: [FeatureConfigFacade],
    },
  ],
})
export class ReinstateFeatureShellModule {
  static forRoot(
    navigationConfig: AppProvidersConfig
  ): ModuleWithProviders<ReinstateFeatureShellModule> {
    return {
      ngModule: ReinstateFeatureShellModule,
      providers: [
        { provide: AppProvidersConfigToken, useValue: navigationConfig },
      ],
    };
  }
}
